<script setup lang="ts">
import type { Segment } from './highlight'

/**
 * Rend un texte segmenté en surlignant les segments marqués.
 *   - variant `leak`  → donnée sensible exposée (brick)
 *   - variant `token` → token de remplacement PreLLM (olive)
 */
defineProps<{ segments: Segment[]; variant: 'leak' | 'token' }>()
</script>

<template>
    <span class="hl">
        <template v-for="(seg, i) in segments" :key="i">
            <mark v-if="seg.highlighted" :class="['hl__mark', `hl__mark--${variant}`]">{{
                seg.text
            }}</mark>
            <template v-else>{{ seg.text }}</template>
        </template>
    </span>
</template>

<style scoped>
.hl {
    white-space: pre-wrap;
    word-break: break-word;
}
.hl__mark {
    border-radius: var(--p-radius-sm);
    padding: 0 3px;
    font-family: var(--p-font-mono);
    font-size: var(--p-text-xs);
}
.hl__mark--leak {
    background: var(--p-color-brick-bg);
    color: var(--p-color-brick);
}
.hl__mark--token {
    background: var(--p-color-olive-bg);
    color: var(--p-color-olive);
}
</style>
